import React, { useState,useRef, useEffect } from 'react';
import {Link,useNavigate} from 'react-router-dom' 
import N3rveLogo from './../../../images/N3rveLogo.png'
import PurpleBackIcon from './../../../images/purplebackicon.png'
import Cookies from 'universal-cookie';
import axios from 'axios';
import { Trans, useTranslation} from 'react-i18next'
import i18next from "i18next"
import Checkbox, { checkboxClasses } from '@mui/material/Checkbox';
import CircularProgress from '@mui/material/CircularProgress';
import './Questionaire.css'
import { Cloudinary } from '@cloudinary/url-gen';
import { auto } from '@cloudinary/url-gen/actions/resize';
import { autoGravity } from '@cloudinary/url-gen/qualifiers/gravity';
import { AdvancedImage } from '@cloudinary/react';

function Questionaire({func}) {
    const [question,setQuestion] = useState(1)
    const [quizselection,setQuizSelection] = useState({
                                                      "q1":0,
                                                      "q2":0,
                                                      "q3":0,
                                                      "q4":0,
                                                      "q5":0,
                                                      "q6":0,
                                                      "q7":0,
                                                      "q8":0,
                                                      "q9":0,
                                                      "q10":0
                                                      })
    const [refreshquiz,setRefreshQuiz] = useState(0)
    const [quizDone,setQuizDone] = useState(false)
    const [timeLeft, setTimeLeft] = useState(null);
    const [animationdelay, setAnimationDelay] = useState(null);
    const [dimensions, setDimensions] = useState({ 
            height: window.innerHeight,
            width: window.innerWidth
          })
    const cld = new Cloudinary({ cloud: { cloudName: 'ddvootytq' } })


    useEffect(()=>{
      console.log(quizselection)
    },[refreshquiz])

    const handleResize = () => {
      // console.log(window.innerWidth)
      setDimensions({
      width: window.innerWidth,
      height: window.innerHeight,
      });
    }

    useEffect(() => {
      window.addEventListener("resize", handleResize, false);
    }, []);


    useEffect(() => {
      // exit early when we reach 0
      if (!timeLeft) return;
  
      if(timeLeft===1){
       func(2)
      }
  
      if(timeLeft===0){
         
      }
  
      // save intervalId to clear the interval when the
      // component re-renders
      const intervalId = setInterval(() => {
  
        setTimeLeft(timeLeft - 1);
      }, 1000);
  
      // clear interval on re-render to avoid memory leaks
      return () => clearInterval(intervalId);
      // add timeLeft as a dependency to re-rerun the effect
      // when we update it
    }, [timeLeft]);



    useEffect(() => {
      // exit early when we reach 0
      if (!animationdelay) return;
  
      if(animationdelay===1){
        if(question>0){
          setQuestion(question+1)
        }else{
          setQuestion(-1*question+1)
        }
       
      }
  
      if(animationdelay===0){
         
      }
  
      // save intervalId to clear the interval when the
      // component re-renders
      const intervalId = setInterval(() => {
  
        setAnimationDelay(animationdelay - 1);
      },500);
  
      // clear interval on re-render to avoid memory leaks
      return () => clearInterval(intervalId);
      // add timeLeft as a dependency to re-rerun the effect
      // when we update it
    }, [animationdelay]);

   

  return (
    <div>

       {/* ******************************************** */}


        {/* DESKTOP VIEW */}
       {
            dimensions.width >= 1024 &&
    <div className="QuestionContainer" style={{position:'relative'}}>
        {
          !quizDone && question!==1 && question!==-1 &&
          <div className='QuestionPreviousshow' style={{display:'flex',flexDirection:'row',alignItems:'center',marginLeft:'0.2em',marginBottom:'2.87em',cursor:'pointer',position:'absolute',top:'-5em',marginLeft:'-54em'}} onClick={()=>{
                                                                                                                                                                                                                                  if(question>0){
                                                                                                                                                                                                                                    setQuestion(-1*(question-1))
                                                                                                                                                                                                                                  }else{
                                                                                                                                                                                                                                    setQuestion((question+1))
                                                                                                                                                                                                                                  }
                                                                                                                                                                                                                                  // setQuestion((question-1))
                                                                                                                                                                                                                                  }}>
          <img src={PurpleBackIcon} style={{width:'1.5em',height:'1.5em',marginRight:'0.25em'}}/>
          <div className='PreviousQuestion'>
            Previous Question
          </div>
        </div>
        }


{
          !quizDone &&
          <div className='QuestionPreviousshow' style={{display:'flex',flexDirection:'row',alignItems:'center',marginLeft:'0.2em',marginBottom:'2.87em',cursor:'pointer',position:'absolute',top:'-7em',right:'5em'}} onClick={()=>{
            func(0)}}>
          <div className='PreviousQuestion'>
           Quit
          </div>
        </div>
        }
      

      
        {
         !quizDone &&
          <div style={{display:'flex',flexDirection:'row'}} className={question===1?'QuestionSlideContainershowfromright':'QuestionSlideContainerhidefromright'}>
              <div style={{display:'flex',flexDirection:'column'}}> 
                  <div className='questionnumber'>1 of 10</div>
                  <div className='questionName'>How often do you release music?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'7.5em',marginTop:'1.8em'}}> 
                {
                  quizselection.q1 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q1=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                      Multiple times a year
                  </div>
                }

                {
                  quizselection.q1 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q1=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Multiple times a year
                  </div>
                } 

                {
                  quizselection.q1 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q1=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                      Monthly
                  </div>
                }

                {
                  quizselection.q1 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q1=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Monthly
                  </div>
                } 

                {
                  quizselection.q1 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q1=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                      Occasionally
                  </div>
                }

                {
                  quizselection.q1 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q1=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Occasionally
                  </div>
                } 

                {
                  quizselection.q1 ===4 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q1=4;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                      Rarely
                  </div>
                }

                {
                  quizselection.q1 !==4 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q1=4;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                 Rarely
                  </div>
                } 

                {/* {
                  quizselection.q1 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                } */}
              
                 
              </div>
          </div>
        }

        {
         !quizDone &&
          <div style={{display:'flex',flexDirection:'row'}} className={question===-1?'QuestionSlideContainershowfromleft':'QuestionSlideContainerhidefromleft'}>
              <div style={{display:'flex',flexDirection:'column'}}> 
                  <div className='questionnumber'>1 of 10</div>
                  <div className='questionName'>How often do you release music?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'7.5em',marginTop:'1.8em'}}> 
                {
                  quizselection.q1 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q1=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                      Multiple times a year
                  </div>
                }

                {
                  quizselection.q1 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q1=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Multiple times a year
                  </div>
                } 

                {
                  quizselection.q1 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q1=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                      Monthly
                  </div>
                }

                {
                  quizselection.q1 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q1=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Monthly
                  </div>
                } 

                {
                  quizselection.q1 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q1=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                      Occasionally
                  </div>
                }

                {
                  quizselection.q1 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q1=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Occasionally
                  </div>
                } 

                {
                  quizselection.q1 ===4 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q1=4;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                      Rarely
                  </div>
                }

                {
                  quizselection.q1 !==4 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q1=4;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                 Rarely
                  </div>
                } 

                {
                  quizselection.q1 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(-1*question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
              
                 
              </div>
          </div>
        }

        {
         !quizDone &&
          <div style={{display:'flex',flexDirection:'row'}} className={question===2?'QuestionSlideContainershow':'QuestionSlideContainerhide'}>
              
              <div style={{display:'flex',flexDirection:'column'}}> 
                  
                  <div className='questionnumber'>2 of 10</div>
                  <div className='questionName'>Do you require detailed analytics to understand your audience?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'7.5em',marginTop:'1.8em'}}> 
                {
                  quizselection.q2 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q2=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                      Yes, I need detailed insights
                  </div>
                }

                {
                  quizselection.q2 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q2=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                Yes, I need detailed insights
                  </div>
                } 

                {
                  quizselection.q2 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q2=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     Basic insights are enough
                  </div>
                }

                {
                  quizselection.q2 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q2=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Basic insights are enough
                  </div>
                } 

                {/* {
                  quizselection.q2 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                } */}
                 
              </div>
          </div>
        }

{
         !quizDone &&
          <div style={{display:'flex',flexDirection:'row'}} className={question===-2?'QuestionSlideContainershowfromleft':'QuestionSlideContainerhidefromleft'}>
              
              <div style={{display:'flex',flexDirection:'column'}}> 
                  
                  <div className='questionnumber'>2 of 10</div>
                  <div className='questionName'>Do you require detailed analytics to understand your audience?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'7.5em',marginTop:'1.8em'}}> 
                {
                  quizselection.q2 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q2=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                      Yes, I need detailed insights
                  </div>
                }

                {
                  quizselection.q2 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q2=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                Yes, I need detailed insights
                  </div>
                } 

                {
                  quizselection.q2 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q2=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     Basic insights are enough
                  </div>
                }

                {
                  quizselection.q2 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q2=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Basic insights are enough
                  </div>
                } 

                {
                  quizselection.q2 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(-1*question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
                 
              </div>
          </div>
        }

{
          !quizDone &&
          <div style={{display:'flex',flexDirection:'row'}} className={question===3?'QuestionSlideContainershow':'QuestionSlideContainerhide'}>
            
              <div style={{display:'flex',flexDirection:'column'}}> 
                 
                  <div className='questionnumber'>3 of 10</div>
                  <div className='questionName'>How important is professional promotion for your music?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'7.5em',marginTop:'1.8em'}}> 
                {
                  quizselection.q3 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q3=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     Very important, I want full support
                  </div>
                }

                {
                  quizselection.q3 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q3=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
               Very important, I want full support
                  </div>
                } 

                {
                  quizselection.q3 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q3=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     Somewhat important
                  </div>
                }

                {
                  quizselection.q3 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q3=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Somewhat important
                  </div>
                } 

              {
                  quizselection.q3 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q3=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     I manage my own promotions
                  </div>
                }

                {
                  quizselection.q3 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q3=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  I manage my own promotions
                  </div>
                } 

                {/* {
                  quizselection.q3 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                } */}
                 
              </div>
          </div>
        }

{
          !quizDone &&
          <div style={{display:'flex',flexDirection:'row'}} className={question===-3?'QuestionSlideContainershowfromleft':'QuestionSlideContainerhidefromleft'}>
            
              <div style={{display:'flex',flexDirection:'column'}}> 
                 
                  <div className='questionnumber'>3 of 10</div>
                  <div className='questionName'>How important is professional promotion for your music?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'7.5em',marginTop:'1.8em'}}> 
                {
                  quizselection.q3 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q3=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     Very important, I want full support
                  </div>
                }

                {
                  quizselection.q3 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q3=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
               Very important, I want full support
                  </div>
                } 

                {
                  quizselection.q3 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q3=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     Somewhat important
                  </div>
                }

                {
                  quizselection.q3 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q3=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Somewhat important
                  </div>
                } 

              {
                  quizselection.q3 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q3=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     I manage my own promotions
                  </div>
                }

                {
                  quizselection.q3 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q3=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  I manage my own promotions
                  </div>
                } 

                {
                  quizselection.q3 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(-1*question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
                 
              </div>
          </div>
        }

      {
           !quizDone &&
          <div style={{display:'flex',flexDirection:'row'}} className={question===4?'QuestionSlideContainershow':'QuestionSlideContainerhide'}>
            
              <div style={{display:'flex',flexDirection:'column'}}> 
                  
                  <div className='questionnumber'>4 of 10</div>
                  <div className='questionName'>Are you looking for exclusive collaboration opportunities?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'7.5em',marginTop:'1.8em'}}> 
                {
                  quizselection.q4 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q4=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     Yes, frequently
                  </div>
                }

                {
                  quizselection.q4 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q4=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Yes, frequently
                  </div>
                } 

                {
                  quizselection.q4 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q4=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Occasionally
                  </div>
                }

                {
                  quizselection.q4 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q4=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Occasionally
                  </div>
                } 

                {
                  quizselection.q4 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q4=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Not a priority
                  </div>
                }

                {
                  quizselection.q4 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q4=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Not a priority
                  </div>
                }   

                {/* {
                  quizselection.q4 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
                  */}
              </div>
          </div>
        }

{
           !quizDone &&
          <div style={{display:'flex',flexDirection:'row'}} className={question===-4?'QuestionSlideContainershowfromleft':'QuestionSlideContainerhidefromleft'}>
            
              <div style={{display:'flex',flexDirection:'column'}}> 
                  
                  <div className='questionnumber'>4 of 10</div>
                  <div className='questionName'>Are you looking for exclusive collaboration opportunities?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'7.5em',marginTop:'1.8em'}}> 
                {
                  quizselection.q4 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q4=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     Yes, frequently
                  </div>
                }

                {
                  quizselection.q4 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q4=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Yes, frequently
                  </div>
                } 

                {
                  quizselection.q4 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q4=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Occasionally
                  </div>
                }

                {
                  quizselection.q4 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q4=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Occasionally
                  </div>
                } 

                {
                  quizselection.q4 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q4=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Not a priority
                  </div>
                }

                {
                  quizselection.q4 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q4=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Not a priority
                  </div>
                }   

                {
                  quizselection.q4 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(-1*question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
                 
              </div>
          </div>
        }

      {
           !quizDone &&
          <div style={{display:'flex',flexDirection:'row'}} className={question===5?'QuestionSlideContainershow':'QuestionSlideContainerhide'}>
            
              <div style={{display:'flex',flexDirection:'column'}}> 
                
                  <div className='questionnumber'>5 of 10</div>
                  <div className='questionName'>Do you want your music on all major streaming platforms?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'7.5em',marginTop:'1.8em'}}> 
                {
                  quizselection.q5 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q5=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     Yes, the more the better
                  </div>
                }

                {
                  quizselection.q5 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q5=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Yes, the more the better
                  </div>
                } 

                {
                  quizselection.q5 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q5=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Major platforms only
                  </div>
                }

                {
                  quizselection.q5 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q5=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Major platforms only
                  </div>
                } 

                {
                  quizselection.q5 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q5=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   I'm selective about platforms
                  </div>
                }

                {
                  quizselection.q5 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q5=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   I'm selective about platforms
                  </div>
                }   

                {/* {
                  quizselection.q5 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                } */}
               
                 
              </div>
          </div>
        }

{
           !quizDone &&
          <div style={{display:'flex',flexDirection:'row'}} className={question===-5?'QuestionSlideContainershowfromleft':'QuestionSlideContainerhidefromleft'}>
            
              <div style={{display:'flex',flexDirection:'column'}}> 
                
                  <div className='questionnumber'>5 of 10</div>
                  <div className='questionName'>Do you want your music on all major streaming platforms?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'7.5em',marginTop:'1.8em'}}> 
                {
                  quizselection.q5 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q5=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     Yes, the more the better
                  </div>
                }

                {
                  quizselection.q5 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q5=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Yes, the more the better
                  </div>
                } 

                {
                  quizselection.q5 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q5=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Major platforms only
                  </div>
                }

                {
                  quizselection.q5 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q5=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Major platforms only
                  </div>
                } 

                {
                  quizselection.q5 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q5=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   I'm selective about platforms
                  </div>
                }

                {
                  quizselection.q5 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q5=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   I'm selective about platforms
                  </div>
                }   

                {
                  quizselection.q5 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(-1*question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
               
                 
              </div>
          </div>
        }

        {
          !quizDone &&
          <div style={{display:'flex',flexDirection:'row'}} className={question===6?'QuestionSlideContainershow':'QuestionSlideContainerhide'}>
            
              <div style={{display:'flex',flexDirection:'column'}}> 
                  
                  <div className='questionnumber'>6 of 10</div>
                  <div className='questionName'>What are your primary financial goals for your music?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'7.5em',marginTop:'1.8em'}}> 
                {
                  quizselection.q6 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q6=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Maximize earnings
                  </div>
                }

                {
                  quizselection.q6 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q6=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Maximize earnings
                  </div>
                } 

                {
                  quizselection.q6 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q6=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Cover production costs
                  </div>
                }

                {
                  quizselection.q6 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q6=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Cover production costs
                  </div>
                } 

                {
                  quizselection.q6 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q6=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Revenue is not a priority
                  </div>
                }

                {
                  quizselection.q6 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q6=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Revenue is not a priority
                  </div>
                }   

                {/* {
                  quizselection.q6 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
                  */}
              </div>
          </div>
        }

{
          !quizDone &&
          <div style={{display:'flex',flexDirection:'row'}} className={question===-6?'QuestionSlideContainershowfromleft':'QuestionSlideContainerhidefromleft'}>
            
              <div style={{display:'flex',flexDirection:'column'}}> 
                  
                  <div className='questionnumber'>6 of 10</div>
                  <div className='questionName'>What are your primary financial goals for your music?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'7.5em',marginTop:'1.8em'}}> 
                {
                  quizselection.q6 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q6=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Maximize earnings
                  </div>
                }

                {
                  quizselection.q6 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q6=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Maximize earnings
                  </div>
                } 

                {
                  quizselection.q6 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q6=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Cover production costs
                  </div>
                }

                {
                  quizselection.q6 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q6=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Cover production costs
                  </div>
                } 

                {
                  quizselection.q6 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q6=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Revenue is not a priority
                  </div>
                }

                {
                  quizselection.q6 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q6=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Revenue is not a priority
                  </div>
                }   

                {
                  quizselection.q6 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(-1*question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
                 
              </div>
          </div>
        }

      {
          !quizDone &&
          <div style={{display:'flex',flexDirection:'row'}} className={question===7?'QuestionSlideContainershow':'QuestionSlideContainerhide'}>
            
              <div style={{display:'flex',flexDirection:'column'}}> 
                
                  <div className='questionnumber'>7 of 10</div>
                  <div className='questionName'>What types of content do you primarily produce?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'7.5em',marginTop:'1.8em'}}> 
                {
                  quizselection.q7 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q7=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Music tracks
                  </div>
                }

                {
                  quizselection.q7 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q7=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Music tracks
                  </div>
                } 

                {
                  quizselection.q7 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q7=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Music videos
                  </div>
                }

                {
                  quizselection.q7 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q7=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Music videos
                  </div>
                } 

                {
                  quizselection.q7 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q7=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Live performances
                  </div>
                }

                {
                  quizselection.q7 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q7=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Live performances
                  </div>
                }   

                {
                  quizselection.q7 ===4 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q7=4;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Podcasts
                  </div>
                }

                {
                  quizselection.q7 !==4 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q7=4;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                 Podcasts
                  </div>
                }   

                {/* {
                  quizselection.q7 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                } */}
                 
              </div>
          </div>
        }

{
          !quizDone &&
          <div style={{display:'flex',flexDirection:'row'}} className={question===-7?'QuestionSlideContainershowfromleft':'QuestionSlideContainerhidefromleft'}>
            
              <div style={{display:'flex',flexDirection:'column'}}> 
                
                  <div className='questionnumber'>7 of 10</div>
                  <div className='questionName'>What types of content do you primarily produce?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'7.5em',marginTop:'1.8em'}}> 
                {
                  quizselection.q7 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q7=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Music tracks
                  </div>
                }

                {
                  quizselection.q7 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q7=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Music tracks
                  </div>
                } 

                {
                  quizselection.q7 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q7=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Music videos
                  </div>
                }

                {
                  quizselection.q7 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q7=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Music videos
                  </div>
                } 

                {
                  quizselection.q7 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q7=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Live performances
                  </div>
                }

                {
                  quizselection.q7 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q7=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Live performances
                  </div>
                }   

                {
                  quizselection.q7 ===4 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q7=4;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Podcasts
                  </div>
                }

                {
                  quizselection.q7 !==4 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q7=4;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                 Podcasts
                  </div>
                }   

                {
                  quizselection.q7 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(-1*question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
                 
              </div>
          </div>
        }

      {
          !quizDone &&
          <div style={{display:'flex',flexDirection:'row'}} className={question===8?'QuestionSlideContainershow':'QuestionSlideContainerhide'}>
            
              <div style={{display:'flex',flexDirection:'column'}}> 
                  
                  <div className='questionnumber'>8 of 10</div>
                  <div className='questionName'>Is international distribution important to you?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'7.5em',marginTop:'1.8em'}}> 
                {
                  quizselection.q8 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q8=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Yes, I want global reach
                  </div>
                }

                {
                  quizselection.q8 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q8=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Yes, I want global reach
                  </div>
                } 

                {
                  quizselection.q8 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q8=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  I prefer to focus on specific markets
                  </div>
                }

                {
                  quizselection.q8 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q8=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  I prefer to focus on specific markets
                  </div>
                } 

                {
                  quizselection.q8 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q8=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                 Local distribution is my focus
                  </div>
                }

                {
                  quizselection.q8 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q8=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Local distribution is my focus
                  </div>
                }  
               
               {/* {
                  quizselection.q8 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                } */}
                 
              </div>
          </div>
        } 

{
          !quizDone &&
          <div style={{display:'flex',flexDirection:'row'}} className={question===-8?'QuestionSlideContainershowfromleft':'QuestionSlideContainerhidefromleft'}>
            
              <div style={{display:'flex',flexDirection:'column'}}> 
                  
                  <div className='questionnumber'>8 of 10</div>
                  <div className='questionName'>Is international distribution important to you?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'7.5em',marginTop:'1.8em'}}> 
                {
                  quizselection.q8 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q8=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Yes, I want global reach
                  </div>
                }

                {
                  quizselection.q8 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q8=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Yes, I want global reach
                  </div>
                } 

                {
                  quizselection.q8 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q8=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  I prefer to focus on specific markets
                  </div>
                }

                {
                  quizselection.q8 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q8=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  I prefer to focus on specific markets
                  </div>
                } 

                {
                  quizselection.q8 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q8=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                 Local distribution is my focus
                  </div>
                }

                {
                  quizselection.q8 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q8=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Local distribution is my focus
                  </div>
                }  
               
               {
                  quizselection.q8 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(-1*question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
                 
              </div>
          </div>
        } 

        {
         !quizDone &&
          <div style={{display:'flex',flexDirection:'row'}} className={question===9?'QuestionSlideContainershow':'QuestionSlideContainerhide'}>
            
              <div style={{display:'flex',flexDirection:'column'}}> 
                  
                  <div className='questionnumber'>9 of 10</div>
                  <div className='questionName'>How important is managing your music rights to you?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'7.5em',marginTop:'1.8em'}}> 
                {
                  quizselection.q9 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q9=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Very important—I want full control and protection
                  </div>
                }

                {
                  quizselection.q9 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q9=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Very important—I want full control and protection
                  </div>
                } 

                {
                  quizselection.q9 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q9=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Somewhat important
                  </div>
                }

                {
                  quizselection.q9 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q9=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Somewhat important
                  </div>
                } 

                {
                  quizselection.q9 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q9=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  I'm not sure
                  </div>
                }

                {
                  quizselection.q9 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q9=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  I'm not sure
                  </div>
                }  

                {/* {
                  quizselection.q9 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                } */}
                 
              </div>
          </div>
        }   

{
         !quizDone &&
          <div style={{display:'flex',flexDirection:'row'}} className={question===-9?'QuestionSlideContainershowfromleft':'QuestionSlideContainerhidefromleft'}>
            
              <div style={{display:'flex',flexDirection:'column'}}> 
                  
                  <div className='questionnumber'>9 of 10</div>
                  <div className='questionName'>How important is managing your music rights to you?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'7.5em',marginTop:'1.8em'}}> 
                {
                  quizselection.q9 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q9=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Very important—I want full control and protection
                  </div>
                }

                {
                  quizselection.q9 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q9=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Very important—I want full control and protection
                  </div>
                } 

                {
                  quizselection.q9 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q9=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Somewhat important
                  </div>
                }

                {
                  quizselection.q9 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q9=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Somewhat important
                  </div>
                } 

                {
                  quizselection.q9 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q9=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  I'm not sure
                  </div>
                }

                {
                  quizselection.q9 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q9=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  I'm not sure
                  </div>
                }  

                {
                  quizselection.q9 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(-1*question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
                 
              </div>
          </div>
        }   

        {
           !quizDone &&
          <div style={{display:'flex',flexDirection:'row'}} className={question===10?'QuestionSlideContainershow':'QuestionSlideContainerhide'}>
            
              <div style={{display:'flex',flexDirection:'column'}}> 
                
                  <div className='questionnumber'>10 of 10</div>
                  <div className='questionName'>How much technical support do you anticipate needing?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'7.5em',marginTop:'1.8em'}}> 
                {
                  quizselection.q10 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q10=1;setQuizDone(true);setRefreshQuiz(Math.random());setTimeLeft(5)}}>
                  A lot—I want hands-on assistance
                  </div>
                }

                {
                  quizselection.q10 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q10=1;setQuizDone(true);setRefreshQuiz(Math.random());setTimeLeft(5)}}>
                  A lot—I want hands-on assistance
                  </div>
                } 

                {
                  quizselection.q10 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q10=2;setQuizDone(true);setRefreshQuiz(Math.random());setTimeLeft(5)}}>
                  Occasional help
                  </div>
                }

                {
                  quizselection.q10 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q10=2;setQuizDone(true);setRefreshQuiz(Math.random());setTimeLeft(5)}}>
                  Occasional help
                  </div>
                } 

                {
                  quizselection.q10 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q10=3;setQuizDone(true);setRefreshQuiz(Math.random());setTimeLeft(5)}}>
                  I can manage on my own
                  </div>
                }

                {
                  quizselection.q10 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q10=3;setQuizDone(true);setRefreshQuiz(Math.random());setTimeLeft(5)}}>
                  I can manage on my own
                  </div>
                }  
               
                 
              </div>
          </div>
        }  
         

        {
          quizDone &&
          <div style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',marginTop:'-18.87em'}}>
            <div className='FindingPlan'>
              Finding the best plan...
            </div>
            <CircularProgress style={{width:'5em',height:'5em',marginTop:'2.5em'}} sx={{color:'#E91353'}}/>
          </div>
        }

    </div>
    }







     {/* ******************************************** */}


        {/* TABLET VIEW */}
        {
            dimensions.width >= 768 && dimensions.width <1024 &&
    <div className="QuestionContainer" style={{position:'relative'}}>
        {
          !quizDone && question!==1 && question!==-1 &&
          <div className='QuestionPreviousshow' style={{display:'flex',flexDirection:'row',alignItems:'center',marginLeft:'0.2em',marginBottom:'2.87em',cursor:'pointer',position:'absolute',top:'-5em',left:'0em'}} onClick={()=>{
                                                                                                                                                                                                                                  if(question>0){
                                                                                                                                                                                                                                    setQuestion(-1*(question-1))
                                                                                                                                                                                                                                  }else{
                                                                                                                                                                                                                                    setQuestion((question+1))
                                                                                                                                                                                                                                  }
                                                                                                                                                                                                                                  // setQuestion((question-1))
                                                                                                                                                                                                                                  }}>
          <img src={PurpleBackIcon} style={{width:'1.5em',height:'1.5em',marginRight:'0.25em'}}/>
          <div className='PreviousQuestion'>
            Previous Question
          </div>
        </div>
        }
      {
          !quizDone &&
          <div className='QuestionPreviousshow' style={{display:'flex',flexDirection:'row',alignItems:'center',marginLeft:'0.2em',marginBottom:'2.87em',cursor:'pointer',position:'absolute',top:'-5em',right:'5em'}} onClick={()=>{
            func(0)}}>
          <div className='PreviousQuestion'>
           Quit
          </div>
        </div>
        }

      
        {
         !quizDone &&
          <div style={{display:'flex',flexDirection:'row',justifyContent:'center',width:'95%'}} className={question===1?'QuestionSlideContainershowfromright':'QuestionSlideContainerhidefromright'}>
              <div style={{display:'flex',flexDirection:'column',marginLeft:'1em'}}> 
                  <div className='questionnumber'>1 of 10</div>
                  <div className='questionName'>How often do you release music?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'0.5em',marginTop:'1.8em'}}> 
                {
                  quizselection.q1 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q1=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                      Multiple times a year
                  </div>
                }

                {
                  quizselection.q1 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q1=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Multiple times a year
                  </div>
                } 

                {
                  quizselection.q1 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q1=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                      Monthly
                  </div>
                }

                {
                  quizselection.q1 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q1=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Monthly
                  </div>
                } 

                {
                  quizselection.q1 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q1=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                      Occasionally
                  </div>
                }

                {
                  quizselection.q1 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q1=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Occasionally
                  </div>
                } 

                {
                  quizselection.q1 ===4 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q1=4;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                      Rarely
                  </div>
                }

                {
                  quizselection.q1 !==4 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q1=4;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                 Rarely
                  </div>
                } 

                {/* {
                  quizselection.q1 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                } */}
              
                 
              </div>
          </div>
        }

        {
         !quizDone &&
          <div style={{display:'flex',flexDirection:'row',justifyContent:'center',width:'95%'}} className={question===-1?'QuestionSlideContainershowfromleft':'QuestionSlideContainerhidefromleft'}>
              <div style={{display:'flex',flexDirection:'column'}}> 
                  <div className='questionnumber'>1 of 10</div>
                  <div className='questionName'>How often do you release music?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'0.5em',marginRight:'1em',marginTop:'1.8em'}}> 
                {
                  quizselection.q1 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q1=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                      Multiple times a year
                  </div>
                }

                {
                  quizselection.q1 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q1=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Multiple times a year
                  </div>
                } 

                {
                  quizselection.q1 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q1=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                      Monthly
                  </div>
                }

                {
                  quizselection.q1 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q1=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Monthly
                  </div>
                } 

                {
                  quizselection.q1 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q1=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                      Occasionally
                  </div>
                }

                {
                  quizselection.q1 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q1=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Occasionally
                  </div>
                } 

                {
                  quizselection.q1 ===4 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q1=4;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                      Rarely
                  </div>
                }

                {
                  quizselection.q1 !==4 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q1=4;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                 Rarely
                  </div>
                } 

                {
                  quizselection.q1 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(-1*question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
              
                 
              </div>
          </div>
        }

        {
         !quizDone &&
          <div style={{display:'flex',flexDirection:'row',justifyContent:'center',width:'95%'}} className={question===2?'QuestionSlideContainershow':'QuestionSlideContainerhide'}>
              
              <div style={{display:'flex',flexDirection:'column',marginLeft:'1em'}}> 
                  
                  <div className='questionnumber'>2 of 10</div>
                  <div className='questionName'>Do you require detailed analytics to understand your audience?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'0.5em',marginTop:'1.8em'}}> 
                {
                  quizselection.q2 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q2=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                      Yes, I need detailed insights
                  </div>
                }

                {
                  quizselection.q2 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q2=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                Yes, I need detailed insights
                  </div>
                } 

                {
                  quizselection.q2 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q2=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     Basic insights are enough
                  </div>
                }

                {
                  quizselection.q2 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q2=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Basic insights are enough
                  </div>
                } 

                {/* {
                  quizselection.q2 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                } */}
                 
              </div>
          </div>
        }

{
         !quizDone &&
          <div style={{display:'flex',flexDirection:'row',width:'95%'}} className={question===-2?'QuestionSlideContainershowfromleft':'QuestionSlideContainerhidefromleft'}>
              
              <div style={{display:'flex',flexDirection:'column'}}> 
                  
                  <div className='questionnumber'>2 of 10</div>
                  <div className='questionName'>Do you require detailed analytics to understand your audience?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'0.5em',marginRight:'1em',marginTop:'1.8em'}}> 
                {
                  quizselection.q2 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q2=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                      Yes, I need detailed insights
                  </div>
                }

                {
                  quizselection.q2 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q2=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                Yes, I need detailed insights
                  </div>
                } 

                {
                  quizselection.q2 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q2=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     Basic insights are enough
                  </div>
                }

                {
                  quizselection.q2 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q2=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Basic insights are enough
                  </div>
                } 

                {
                  quizselection.q2 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(-1*question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
                 
              </div>
          </div>
        }

{
          !quizDone &&
          <div style={{display:'flex',flexDirection:'row',width:'95%'}} className={question===3?'QuestionSlideContainershow':'QuestionSlideContainerhide'}>
            
              <div style={{display:'flex',flexDirection:'column',marginLeft:'1em'}}> 
                 
                  <div className='questionnumber'>3 of 10</div>
                  <div className='questionName'>How important is professional promotion for your music?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'0.5em',marginTop:'1.8em'}}> 
                {
                  quizselection.q3 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q3=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     Very important, I want full support
                  </div>
                }

                {
                  quizselection.q3 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q3=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
               Very important, I want full support
                  </div>
                } 

                {
                  quizselection.q3 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q3=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     Somewhat important
                  </div>
                }

                {
                  quizselection.q3 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q3=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Somewhat important
                  </div>
                } 

              {
                  quizselection.q3 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q3=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     I manage my own promotions
                  </div>
                }

                {
                  quizselection.q3 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q3=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  I manage my own promotions
                  </div>
                } 

                {/* {
                  quizselection.q3 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                } */}
                 
              </div>
          </div>
        }

{
          !quizDone &&
          <div style={{display:'flex',flexDirection:'row',width:'95%'}} className={question===-3?'QuestionSlideContainershowfromleft':'QuestionSlideContainerhidefromleft'}>
            
              <div style={{display:'flex',flexDirection:'column'}}> 
                 
                  <div className='questionnumber'>3 of 10</div>
                  <div className='questionName'>How important is professional promotion for your music?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'0.5em',marginRight:'1em',marginTop:'1.8em'}}> 
                {
                  quizselection.q3 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q3=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     Very important, I want full support
                  </div>
                }

                {
                  quizselection.q3 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q3=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
               Very important, I want full support
                  </div>
                } 

                {
                  quizselection.q3 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q3=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     Somewhat important
                  </div>
                }

                {
                  quizselection.q3 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q3=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Somewhat important
                  </div>
                } 

              {
                  quizselection.q3 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q3=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     I manage my own promotions
                  </div>
                }

                {
                  quizselection.q3 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q3=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  I manage my own promotions
                  </div>
                } 

                {
                  quizselection.q3 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(-1*question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
                 
              </div>
          </div>
        }

      {
           !quizDone &&
          <div style={{display:'flex',flexDirection:'row',width:'95%'}} className={question===4?'QuestionSlideContainershow':'QuestionSlideContainerhide'}>
            
              <div style={{display:'flex',flexDirection:'column',marginLeft:'1em'}}> 
                  
                  <div className='questionnumber'>4 of 10</div>
                  <div className='questionName'>Are you looking for exclusive collaboration opportunities?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'0.5em',marginTop:'1.8em'}}> 
                {
                  quizselection.q4 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q4=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     Yes, frequently
                  </div>
                }

                {
                  quizselection.q4 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q4=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Yes, frequently
                  </div>
                } 

                {
                  quizselection.q4 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q4=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Occasionally
                  </div>
                }

                {
                  quizselection.q4 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q4=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Occasionally
                  </div>
                } 

                {
                  quizselection.q4 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q4=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Not a priority
                  </div>
                }

                {
                  quizselection.q4 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q4=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Not a priority
                  </div>
                }   

                {/* {
                  quizselection.q4 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
                  */}
              </div>
          </div>
        }

{
           !quizDone &&
          <div style={{display:'flex',flexDirection:'row',width:'95%'}} className={question===-4?'QuestionSlideContainershowfromleft':'QuestionSlideContainerhidefromleft'}>
            
              <div style={{display:'flex',flexDirection:'column'}}> 
                  
                  <div className='questionnumber'>4 of 10</div>
                  <div className='questionName'>Are you looking for exclusive collaboration opportunities?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'0.5em',marginRight:'1em',marginTop:'1.8em'}}> 
                {
                  quizselection.q4 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q4=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     Yes, frequently
                  </div>
                }

                {
                  quizselection.q4 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q4=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Yes, frequently
                  </div>
                } 

                {
                  quizselection.q4 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q4=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Occasionally
                  </div>
                }

                {
                  quizselection.q4 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q4=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Occasionally
                  </div>
                } 

                {
                  quizselection.q4 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q4=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Not a priority
                  </div>
                }

                {
                  quizselection.q4 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q4=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Not a priority
                  </div>
                }   

                {
                  quizselection.q4 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(-1*question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
                 
              </div>
          </div>
        }

      {
           !quizDone &&
          <div style={{display:'flex',flexDirection:'row',width:'95%'}} className={question===5?'QuestionSlideContainershow':'QuestionSlideContainerhide'}>
            
              <div style={{display:'flex',flexDirection:'column',marginLeft:'1em'}}> 
                
                  <div className='questionnumber'>5 of 10</div>
                  <div className='questionName'>Do you want your music on all major streaming platforms?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'0.5em',marginTop:'1.8em'}}> 
                {
                  quizselection.q5 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q5=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     Yes, the more the better
                  </div>
                }

                {
                  quizselection.q5 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q5=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Yes, the more the better
                  </div>
                } 

                {
                  quizselection.q5 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q5=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Major platforms only
                  </div>
                }

                {
                  quizselection.q5 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q5=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Major platforms only
                  </div>
                } 

                {
                  quizselection.q5 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q5=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   I'm selective about platforms
                  </div>
                }

                {
                  quizselection.q5 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q5=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   I'm selective about platforms
                  </div>
                }   

                {/* {
                  quizselection.q5 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                } */}
               
                 
              </div>
          </div>
        }

{
           !quizDone &&
          <div style={{display:'flex',flexDirection:'row',width:'95%'}} className={question===-5?'QuestionSlideContainershowfromleft':'QuestionSlideContainerhidefromleft'}>
            
              <div style={{display:'flex',flexDirection:'column'}}> 
                
                  <div className='questionnumber'>5 of 10</div>
                  <div className='questionName'>Do you want your music on all major streaming platforms?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'0.5em',marginRight:'1em',marginTop:'1.8em'}}> 
                {
                  quizselection.q5 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q5=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     Yes, the more the better
                  </div>
                }

                {
                  quizselection.q5 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q5=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Yes, the more the better
                  </div>
                } 

                {
                  quizselection.q5 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q5=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Major platforms only
                  </div>
                }

                {
                  quizselection.q5 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q5=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Major platforms only
                  </div>
                } 

                {
                  quizselection.q5 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q5=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   I'm selective about platforms
                  </div>
                }

                {
                  quizselection.q5 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q5=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   I'm selective about platforms
                  </div>
                }   

                {
                  quizselection.q5 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(-1*question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
               
                 
              </div>
          </div>
        }

        {
          !quizDone &&
          <div style={{display:'flex',flexDirection:'row',width:'95%'}} className={question===6?'QuestionSlideContainershow':'QuestionSlideContainerhide'}>
            
              <div style={{display:'flex',flexDirection:'column',marginLeft:'1em'}}> 
                  
                  <div className='questionnumber'>6 of 10</div>
                  <div className='questionName'>What are your primary financial goals for your music?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'0.5em',marginTop:'1.8em'}}> 
                {
                  quizselection.q6 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q6=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Maximize earnings
                  </div>
                }

                {
                  quizselection.q6 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q6=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Maximize earnings
                  </div>
                } 

                {
                  quizselection.q6 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q6=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Cover production costs
                  </div>
                }

                {
                  quizselection.q6 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q6=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Cover production costs
                  </div>
                } 

                {
                  quizselection.q6 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q6=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Revenue is not a priority
                  </div>
                }

                {
                  quizselection.q6 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q6=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Revenue is not a priority
                  </div>
                }   

                {/* {
                  quizselection.q6 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
                  */}
              </div>
          </div>
        }

{
          !quizDone &&
          <div style={{display:'flex',flexDirection:'row',width:'95%'}} className={question===-6?'QuestionSlideContainershowfromleft':'QuestionSlideContainerhidefromleft'}>
            
              <div style={{display:'flex',flexDirection:'column'}}> 
                  
                  <div className='questionnumber'>6 of 10</div>
                  <div className='questionName'>What are your primary financial goals for your music?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'0.5em',marginRight:'1em',marginTop:'1.8em'}}> 
                {
                  quizselection.q6 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q6=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Maximize earnings
                  </div>
                }

                {
                  quizselection.q6 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q6=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Maximize earnings
                  </div>
                } 

                {
                  quizselection.q6 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q6=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Cover production costs
                  </div>
                }

                {
                  quizselection.q6 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q6=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Cover production costs
                  </div>
                } 

                {
                  quizselection.q6 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q6=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Revenue is not a priority
                  </div>
                }

                {
                  quizselection.q6 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q6=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Revenue is not a priority
                  </div>
                }   

                {
                  quizselection.q6 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(-1*question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
                 
              </div>
          </div>
        }

      {
          !quizDone &&
          <div style={{display:'flex',flexDirection:'row',width:'95%'}} className={question===7?'QuestionSlideContainershow':'QuestionSlideContainerhide'}>
            
              <div style={{display:'flex',flexDirection:'column',marginLeft:'1em'}}> 
                
                  <div className='questionnumber'>7 of 10</div>
                  <div className='questionName'>What types of content do you primarily produce?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'0.5em',marginTop:'1.8em'}}> 
                {
                  quizselection.q7 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q7=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Music tracks
                  </div>
                }

                {
                  quizselection.q7 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q7=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Music tracks
                  </div>
                } 

                {
                  quizselection.q7 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q7=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Music videos
                  </div>
                }

                {
                  quizselection.q7 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q7=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Music videos
                  </div>
                } 

                {
                  quizselection.q7 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q7=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Live performances
                  </div>
                }

                {
                  quizselection.q7 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q7=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Live performances
                  </div>
                }   

                {
                  quizselection.q7 ===4 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q7=4;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Podcasts
                  </div>
                }

                {
                  quizselection.q7 !==4 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q7=4;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                 Podcasts
                  </div>
                }   

                {/* {
                  quizselection.q7 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                } */}
                 
              </div>
          </div>
        }

{
          !quizDone &&
          <div style={{display:'flex',flexDirection:'row',width:'95%'}} className={question===-7?'QuestionSlideContainershowfromleft':'QuestionSlideContainerhidefromleft'}>
            
              <div style={{display:'flex',flexDirection:'column'}}> 
                
                  <div className='questionnumber'>7 of 10</div>
                  <div className='questionName'>What types of content do you primarily produce?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'0.5em',marginRight:'1em',marginTop:'1.8em'}}> 
                {
                  quizselection.q7 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q7=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Music tracks
                  </div>
                }

                {
                  quizselection.q7 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q7=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Music tracks
                  </div>
                } 

                {
                  quizselection.q7 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q7=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Music videos
                  </div>
                }

                {
                  quizselection.q7 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q7=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Music videos
                  </div>
                } 

                {
                  quizselection.q7 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q7=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Live performances
                  </div>
                }

                {
                  quizselection.q7 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q7=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Live performances
                  </div>
                }   

                {
                  quizselection.q7 ===4 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q7=4;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Podcasts
                  </div>
                }

                {
                  quizselection.q7 !==4 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q7=4;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                 Podcasts
                  </div>
                }   

                {
                  quizselection.q7 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(-1*question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
                 
              </div>
          </div>
        }

      {
          !quizDone &&
          <div style={{display:'flex',flexDirection:'row',width:'95%'}} className={question===8?'QuestionSlideContainershow':'QuestionSlideContainerhide'}>
            
              <div style={{display:'flex',flexDirection:'column',marginLeft:'1em'}}> 
                  
                  <div className='questionnumber'>8 of 10</div>
                  <div className='questionName'>Is international distribution important to you?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'0.5em',marginTop:'1.8em'}}> 
                {
                  quizselection.q8 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q8=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Yes, I want global reach
                  </div>
                }

                {
                  quizselection.q8 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q8=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Yes, I want global reach
                  </div>
                } 

                {
                  quizselection.q8 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q8=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  I prefer to focus on specific markets
                  </div>
                }

                {
                  quizselection.q8 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q8=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  I prefer to focus on specific markets
                  </div>
                } 

                {
                  quizselection.q8 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q8=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                 Local distribution is my focus
                  </div>
                }

                {
                  quizselection.q8 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q8=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Local distribution is my focus
                  </div>
                }  
               
               {/* {
                  quizselection.q8 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                } */}
                 
              </div>
          </div>
        } 

{
          !quizDone &&
          <div style={{display:'flex',flexDirection:'row',width:'95%'}} className={question===-8?'QuestionSlideContainershowfromleft':'QuestionSlideContainerhidefromleft'}>
            
              <div style={{display:'flex',flexDirection:'column'}}> 
                  
                  <div className='questionnumber'>8 of 10</div>
                  <div className='questionName'>Is international distribution important to you?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'0.5em',marginRight:'1em',marginTop:'1.8em'}}> 
                {
                  quizselection.q8 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q8=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Yes, I want global reach
                  </div>
                }

                {
                  quizselection.q8 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q8=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Yes, I want global reach
                  </div>
                } 

                {
                  quizselection.q8 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q8=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  I prefer to focus on specific markets
                  </div>
                }

                {
                  quizselection.q8 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q8=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  I prefer to focus on specific markets
                  </div>
                } 

                {
                  quizselection.q8 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q8=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                 Local distribution is my focus
                  </div>
                }

                {
                  quizselection.q8 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q8=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Local distribution is my focus
                  </div>
                }  
               
               {
                  quizselection.q8 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(-1*question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
                 
              </div>
          </div>
        } 

        {
         !quizDone &&
          <div style={{display:'flex',flexDirection:'row',width:'95%'}} className={question===9?'QuestionSlideContainershow':'QuestionSlideContainerhide'}>
            
              <div style={{display:'flex',flexDirection:'column',marginLeft:'1em'}}> 
                  
                  <div className='questionnumber'>9 of 10</div>
                  <div className='questionName'>How important is managing your music rights to you?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'0.5em',marginTop:'1.8em'}}> 
                {
                  quizselection.q9 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q9=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Very important—I want full control and protection
                  </div>
                }

                {
                  quizselection.q9 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q9=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Very important—I want full control and protection
                  </div>
                } 

                {
                  quizselection.q9 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q9=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Somewhat important
                  </div>
                }

                {
                  quizselection.q9 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q9=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Somewhat important
                  </div>
                } 

                {
                  quizselection.q9 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q9=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  I'm not sure
                  </div>
                }

                {
                  quizselection.q9 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q9=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  I'm not sure
                  </div>
                }  

                {/* {
                  quizselection.q9 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                } */}
                 
              </div>
          </div>
        }   

{
         !quizDone &&
          <div style={{display:'flex',flexDirection:'row',width:'95%'}} className={question===-9?'QuestionSlideContainershowfromleft':'QuestionSlideContainerhidefromleft'}>
            
              <div style={{display:'flex',flexDirection:'column'}}> 
                  
                  <div className='questionnumber'>9 of 10</div>
                  <div className='questionName'>How important is managing your music rights to you?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'0.5em',marginRight:'1em',marginTop:'1.8em'}}> 
                {
                  quizselection.q9 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q9=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Very important—I want full control and protection
                  </div>
                }

                {
                  quizselection.q9 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q9=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Very important—I want full control and protection
                  </div>
                } 

                {
                  quizselection.q9 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q9=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Somewhat important
                  </div>
                }

                {
                  quizselection.q9 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q9=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Somewhat important
                  </div>
                } 

                {
                  quizselection.q9 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q9=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  I'm not sure
                  </div>
                }

                {
                  quizselection.q9 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q9=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  I'm not sure
                  </div>
                }  

                {
                  quizselection.q9 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(-1*question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
                 
              </div>
          </div>
        }   

        {
           !quizDone &&
          <div style={{display:'flex',flexDirection:'row',width:'95%'}} className={question===10?'QuestionSlideContainershow':'QuestionSlideContainerhide'}>
            
              <div style={{display:'flex',flexDirection:'column',marginLeft:'1em'}}> 
                
                  <div className='questionnumber'>10 of 10</div>
                  <div className='questionName'>How much technical support do you anticipate needing?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'flex-start',marginLeft:'0.5em',marginTop:'1.8em'}}> 
                {
                  quizselection.q10 ===1 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q10=1;setQuizDone(true);setRefreshQuiz(Math.random());setTimeLeft(5)}}>
                  A lot—I want hands-on assistance
                  </div>
                }

                {
                  quizselection.q10 !==1 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q10=1;setQuizDone(true);setRefreshQuiz(Math.random());setTimeLeft(5)}}>
                  A lot—I want hands-on assistance
                  </div>
                } 

                {
                  quizselection.q10 ===2 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q10=2;setQuizDone(true);setRefreshQuiz(Math.random());setTimeLeft(5)}}>
                  Occasional help
                  </div>
                }

                {
                  quizselection.q10 !==2 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q10=2;setQuizDone(true);setRefreshQuiz(Math.random());setTimeLeft(5)}}>
                  Occasional help
                  </div>
                } 

                {
                  quizselection.q10 ===3 &&
                  <div className='QuestionOptionContainerSel' onClick={()=>{quizselection.q10=3;setQuizDone(true);setRefreshQuiz(Math.random());setTimeLeft(5)}}>
                  I can manage on my own
                  </div>
                }

                {
                  quizselection.q10 !==3 &&
                  <div className='QuestionOptionContainer' onClick={()=>{quizselection.q10=3;setQuizDone(true);setRefreshQuiz(Math.random());setTimeLeft(5)}}>
                  I can manage on my own
                  </div>
                }  
               
                 
              </div>
          </div>
        }  
         

        {
          quizDone &&
          <div style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',marginTop:'-1.87em'}}>
            <div className='FindingPlan'>
              Finding the best plan...
            </div>
            <CircularProgress style={{width:'5em',height:'5em',marginTop:'2.5em'}} sx={{color:'#E91353'}}/>
          </div>
        }

    </div>
    }









      {/* ******************************************** */}


        {/* MOBILE VIEW */}
        {
          dimensions.width < 768 &&
        <div className="QuestionContainer" style={{position:'relative'}}>
        {
          !quizDone && question!==1 && question!==-1 &&
          <div className='QuestionPreviousshow' style={{display:'flex',flexDirection:'row',alignItems:'center',marginLeft:'0.2em',marginBottom:'2.87em',cursor:'pointer',position:'absolute',top:'-6em',left:'0em'}} onClick={()=>{
                                                                                                                                                                                                                                  if(question>0){
                                                                                                                                                                                                                                    setQuestion(-1*(question-1))
                                                                                                                                                                                                                                  }else{
                                                                                                                                                                                                                                    setQuestion((question+1))
                                                                                                                                                                                                                                  }
                                                                                                                                                                                                                                  // setQuestion((question-1))
                                                                                                                                                                                                                                  }}>
          <img src={PurpleBackIcon} style={{width:'1.5em',height:'1.5em',marginRight:'0.25em'}}/>
          <div className='PreviousQuestion'>
            Previous Question
          </div>
        </div>
        }

      {
          !quizDone &&
          <div className='QuestionPreviousshow' style={{display:'flex',flexDirection:'row',alignItems:'center',marginLeft:'0.2em',marginBottom:'2.87em',cursor:'pointer',position:'absolute',top:'-6em',right:'5em'}} onClick={()=>{
            func(0)}}>
          <div className='PreviousQuestion'>
           Quit
          </div>
        </div>
        }
      

      
        {
         !quizDone &&
          <div style={{display:'flex',flexDirection:'column',alignItems:'center',marginTop:'-2em'}} className={question===1?'QuestionSlideContainershowfromright':'QuestionSlideContainerhidefromright'}>
              <div style={{display:'flex',flexDirection:'column',marginLeft:'0.5em'}}> 
                  <div className='questionnumber'>1 of 10</div>
                  <div className='questionName'>How often do you release music?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em',alignSelf:'center'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'100%'}}> 
                {
                  quizselection.q1 ===1 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q1=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                      Multiple times a year
                  </div>
                }

                {
                  quizselection.q1 !==1 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q1=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Multiple times a year
                  </div>
                } 

                {
                  quizselection.q1 ===2 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q1=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                      Monthly
                  </div>
                }

                {
                  quizselection.q1 !==2 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q1=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Monthly
                  </div>
                } 

                {
                  quizselection.q1 ===3 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q1=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                      Occasionally
                  </div>
                }

                {
                  quizselection.q1 !==3 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q1=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Occasionally
                  </div>
                } 

                {
                  quizselection.q1 ===4 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q1=4;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                      Rarely
                  </div>
                }

                {
                  quizselection.q1 !==4 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q1=4;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                 Rarely
                  </div>
                } 

                {/* {
                  quizselection.q1 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                } */}
              
                 
              </div>
          </div>
        }

        {
         !quizDone &&
          <div style={{display:'flex',flexDirection:'column',paddingTop:'0em',marginTop:'-5em'}} className={question===-1?'QuestionSlideContainershowfromleft':'QuestionSlideContainerhidefromleft'}>
              <div style={{display:'flex',flexDirection:'column',marginLeft:'0.5em'}}> 
                  <div className='questionnumber'>1 of 10</div>
                  <div className='questionName'>How often do you release music?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em',alignSelf:'center'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'100%'}}> 
                {
                  quizselection.q1 ===1 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q1=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                      Multiple times a year
                  </div>
                }

                {
                  quizselection.q1 !==1 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q1=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Multiple times a year
                  </div>
                } 

                {
                  quizselection.q1 ===2 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q1=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                      Monthly
                  </div>
                }

                {
                  quizselection.q1 !==2 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q1=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Monthly
                  </div>
                } 

                {
                  quizselection.q1 ===3 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q1=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                      Occasionally
                  </div>
                }

                {
                  quizselection.q1 !==3 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q1=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Occasionally
                  </div>
                } 

                {
                  quizselection.q1 ===4 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q1=4;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                      Rarely
                  </div>
                }

                {
                  quizselection.q1 !==4 &&
                  <div className='QuestionOptionContainer'  style={{width:'80%'}} onClick={()=>{quizselection.q1=4;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                 Rarely
                  </div>
                } 

                {
                  quizselection.q1 !==0 &&
                  <div className='ContinueQuizBtn' style={{width:'80%'}} onClick={()=>setQuestion(-1*question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
              
                 
              </div>
          </div>
        }

        {
         !quizDone &&
          <div style={{display:'flex',flexDirection:'column',marginTop:'0em'}} className={question===2?'QuestionSlideContainershow':'QuestionSlideContainerhide'}>
              
              <div style={{display:'flex',flexDirection:'column',marginLeft:'0.5em'}}> 
                  
                  <div className='questionnumber'>2 of 10</div>
                  <div className='questionName'>Do you require detailed analytics to understand your audience?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em',alignSelf:'center'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'100%'}}> 
                {
                  quizselection.q2 ===1 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q2=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                      Yes, I need detailed insights
                  </div>
                }

                {
                  quizselection.q2 !==1 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q2=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                Yes, I need detailed insights
                  </div>
                } 

                {
                  quizselection.q2 ===2 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q2=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     Basic insights are enough
                  </div>
                }

                {
                  quizselection.q2 !==2 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q2=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Basic insights are enough
                  </div>
                } 

                {/* {
                  quizselection.q2 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                } */}
                 
              </div>
          </div>
        }

{
         !quizDone &&
          <div style={{display:'flex',flexDirection:'column'}} className={question===-2?'QuestionSlideContainershowfromleft':'QuestionSlideContainerhidefromleft'}>
              
              <div style={{display:'flex',flexDirection:'column',marginLeft:'0.5em'}}> 
                  
                  <div className='questionnumber'>2 of 10</div>
                  <div className='questionName'>Do you require detailed analytics to understand your audience?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em',alignSelf:'center'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'100%'}}> 
                {
                  quizselection.q2 ===1 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q2=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                      Yes, I need detailed insights
                  </div>
                }

                {
                  quizselection.q2 !==1 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q2=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                Yes, I need detailed insights
                  </div>
                } 

                {
                  quizselection.q2 ===2 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q2=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     Basic insights are enough
                  </div>
                }

                {
                  quizselection.q2 !==2 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q2=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Basic insights are enough
                  </div>
                } 

                {
                  quizselection.q2 !==0 &&
                  <div className='ContinueQuizBtn' style={{width:'80%'}} onClick={()=>setQuestion(-1*question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
                 
              </div>
          </div>
        }

{
          !quizDone &&
          <div style={{display:'flex',flexDirection:'column'}} className={question===3?'QuestionSlideContainershow':'QuestionSlideContainerhide'}>
            
              <div style={{display:'flex',flexDirection:'column',marginLeft:'0.5em'}}> 
                 
                  <div className='questionnumber'>3 of 10</div>
                  <div className='questionName'>How important is professional promotion for your music?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em',alignSelf:'center'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'100%'}}> 
                {
                  quizselection.q3 ===1 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q3=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     Very important, I want full support
                  </div>
                }

                {
                  quizselection.q3 !==1 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q3=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
               Very important, I want full support
                  </div>
                } 

                {
                  quizselection.q3 ===2 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q3=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     Somewhat important
                  </div>
                }

                {
                  quizselection.q3 !==2 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q3=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Somewhat important
                  </div>
                } 

              {
                  quizselection.q3 ===3 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q3=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     I manage my own promotions
                  </div>
                }

                {
                  quizselection.q3 !==3 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q3=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  I manage my own promotions
                  </div>
                } 

                {/* {
                  quizselection.q3 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                } */}
                 
              </div>
          </div>
        }

{
          !quizDone &&
          <div style={{display:'flex',flexDirection:'column',marginTop:'-2em'}} className={question===-3?'QuestionSlideContainershowfromleft':'QuestionSlideContainerhidefromleft'}>
            
              <div style={{display:'flex',flexDirection:'column',marginLeft:'0.5em'}}> 
                 
                  <div className='questionnumber'>3 of 10</div>
                  <div className='questionName'>How important is professional promotion for your music?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em',alignSelf:'center'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'100%'}}> 
                {
                  quizselection.q3 ===1 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q3=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     Very important, I want full support
                  </div>
                }

                {
                  quizselection.q3 !==1 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q3=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
               Very important, I want full support
                  </div>
                } 

                {
                  quizselection.q3 ===2 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q3=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     Somewhat important
                  </div>
                }

                {
                  quizselection.q3 !==2 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q3=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Somewhat important
                  </div>
                } 

              {
                  quizselection.q3 ===3 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q3=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     I manage my own promotions
                  </div>
                }

                {
                  quizselection.q3 !==3 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q3=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  I manage my own promotions
                  </div>
                } 

                {
                  quizselection.q3 !==0 &&
                  <div className='ContinueQuizBtn' style={{width:'80%'}} onClick={()=>setQuestion(-1*question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
                 
              </div>
          </div>
        }

      {
           !quizDone &&
          <div style={{display:'flex',flexDirection:'column'}} className={question===4?'QuestionSlideContainershow':'QuestionSlideContainerhide'}>
            
              <div style={{display:'flex',flexDirection:'column',marginLeft:'0.5em'}}> 
                  
                  <div className='questionnumber'>4 of 10</div>
                  <div className='questionName'>Are you looking for exclusive collaboration opportunities?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em',alignSelf:'center'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'100%'}}> 
                {
                  quizselection.q4 ===1 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q4=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     Yes, frequently
                  </div>
                }

                {
                  quizselection.q4 !==1 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q4=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Yes, frequently
                  </div>
                } 

                {
                  quizselection.q4 ===2 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q4=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Occasionally
                  </div>
                }

                {
                  quizselection.q4 !==2 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q4=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Occasionally
                  </div>
                } 

                {
                  quizselection.q4 ===3 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q4=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Not a priority
                  </div>
                }

                {
                  quizselection.q4 !==3 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q4=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Not a priority
                  </div>
                }   

                {/* {
                  quizselection.q4 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
                  */}
              </div>
          </div>
        }

{
           !quizDone &&
          <div style={{display:'flex',flexDirection:'column',marginTop:'-2em'}} className={question===-4?'QuestionSlideContainershowfromleft':'QuestionSlideContainerhidefromleft'}>
            
              <div style={{display:'flex',flexDirection:'column',marginLeft:'0.5em'}}> 
                  
                  <div className='questionnumber'>4 of 10</div>
                  <div className='questionName'>Are you looking for exclusive collaboration opportunities?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em',alignSelf:'center'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'100%'}}> 
                {
                  quizselection.q4 ===1 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q4=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     Yes, frequently
                  </div>
                }

                {
                  quizselection.q4 !==1 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q4=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Yes, frequently
                  </div>
                } 

                {
                  quizselection.q4 ===2 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q4=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Occasionally
                  </div>
                }

                {
                  quizselection.q4 !==2 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q4=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Occasionally
                  </div>
                } 

                {
                  quizselection.q4 ===3 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q4=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Not a priority
                  </div>
                }

                {
                  quizselection.q4 !==3 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q4=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Not a priority
                  </div>
                }   

                {
                  quizselection.q4 !==0 &&
                  <div className='ContinueQuizBtn' style={{width:'80%'}} onClick={()=>setQuestion(-1*question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
                 
              </div>
          </div>
        }

      {
           !quizDone &&
          <div style={{display:'flex',flexDirection:'column'}} className={question===5?'QuestionSlideContainershow':'QuestionSlideContainerhide'}>
            
              <div style={{display:'flex',flexDirection:'column',marginLeft:'0.5em'}}> 
                
                  <div className='questionnumber'>5 of 10</div>
                  <div className='questionName'>Do you want your music on all major streaming platforms?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em',alignSelf:'center'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'100%'}}> 
                {
                  quizselection.q5 ===1 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q5=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     Yes, the more the better
                  </div>
                }

                {
                  quizselection.q5 !==1 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q5=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Yes, the more the better
                  </div>
                } 

                {
                  quizselection.q5 ===2 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q5=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Major platforms only
                  </div>
                }

                {
                  quizselection.q5 !==2 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q5=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Major platforms only
                  </div>
                } 

                {
                  quizselection.q5 ===3 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q5=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   I'm selective about platforms
                  </div>
                }

                {
                  quizselection.q5 !==3 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q5=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   I'm selective about platforms
                  </div>
                }   

                {/* {
                  quizselection.q5 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                } */}
               
                 
              </div>
          </div>
        }

{
           !quizDone &&
          <div style={{display:'flex',flexDirection:'column',marginTop:'-2em'}} className={question===-5?'QuestionSlideContainershowfromleft':'QuestionSlideContainerhidefromleft'}>
            
              <div style={{display:'flex',flexDirection:'column',marginLeft:'0.5em'}}> 
                
                  <div className='questionnumber'>5 of 10</div>
                  <div className='questionName'>Do you want your music on all major streaming platforms?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em',alignSelf:'center'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'100%'}}> 
                {
                  quizselection.q5 ===1 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q5=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                     Yes, the more the better
                  </div>
                }

                {
                  quizselection.q5 !==1 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q5=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Yes, the more the better
                  </div>
                } 

                {
                  quizselection.q5 ===2 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q5=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Major platforms only
                  </div>
                }

                {
                  quizselection.q5 !==2 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q5=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Major platforms only
                  </div>
                } 

                {
                  quizselection.q5 ===3 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q5=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   I'm selective about platforms
                  </div>
                }

                {
                  quizselection.q5 !==3 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q5=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   I'm selective about platforms
                  </div>
                }   

                {
                  quizselection.q5 !==0 &&
                  <div className='ContinueQuizBtn' style={{width:'80%'}} onClick={()=>setQuestion(-1*question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
               
                 
              </div>
          </div>
        }

        {
          !quizDone &&
          <div style={{display:'flex',flexDirection:'column'}} className={question===6?'QuestionSlideContainershow':'QuestionSlideContainerhide'}>
            
              <div style={{display:'flex',flexDirection:'column',marginLeft:'0.5em'}}> 
                  
                  <div className='questionnumber'>6 of 10</div>
                  <div className='questionName'>What are your primary financial goals for your music?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em',alignSelf:'center'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'100%'}}> 
                {
                  quizselection.q6 ===1 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q6=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Maximize earnings
                  </div>
                }

                {
                  quizselection.q6 !==1 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q6=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Maximize earnings
                  </div>
                } 

                {
                  quizselection.q6 ===2 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q6=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Cover production costs
                  </div>
                }

                {
                  quizselection.q6 !==2 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q6=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Cover production costs
                  </div>
                } 

                {
                  quizselection.q6 ===3 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q6=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Revenue is not a priority
                  </div>
                }

                {
                  quizselection.q6 !==3 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q6=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Revenue is not a priority
                  </div>
                }   

                {/* {
                  quizselection.q6 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
                  */}
              </div>
          </div>
        }

{
          !quizDone &&
          <div style={{display:'flex',flexDirection:'column',marginTop:'-2em'}} className={question===-6?'QuestionSlideContainershowfromleft':'QuestionSlideContainerhidefromleft'}>
            
              <div style={{display:'flex',flexDirection:'column',marginLeft:'0.5em'}}> 
                  
                  <div className='questionnumber'>6 of 10</div>
                  <div className='questionName'>What are your primary financial goals for your music?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em',alignSelf:'center'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'100%'}}> 
                {
                  quizselection.q6 ===1 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q6=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                    Maximize earnings
                  </div>
                }

                {
                  quizselection.q6 !==1 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q6=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Maximize earnings
                  </div>
                } 

                {
                  quizselection.q6 ===2 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q6=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Cover production costs
                  </div>
                }

                {
                  quizselection.q6 !==2 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q6=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Cover production costs
                  </div>
                } 

                {
                  quizselection.q6 ===3 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q6=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Revenue is not a priority
                  </div>
                }

                {
                  quizselection.q6 !==3 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q6=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Revenue is not a priority
                  </div>
                }   

                {
                  quizselection.q6 !==0 &&
                  <div className='ContinueQuizBtn' style={{width:'80%'}} onClick={()=>setQuestion(-1*question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
                 
              </div>
          </div>
        }

      {
          !quizDone &&
          <div style={{display:'flex',flexDirection:'column',marginTop:'-2em'}} className={question===7?'QuestionSlideContainershow':'QuestionSlideContainerhide'}>
            
              <div style={{display:'flex',flexDirection:'column',marginLeft:'0.5em'}}> 
                
                  <div className='questionnumber'>7 of 10</div>
                  <div className='questionName'>What types of content do you primarily produce?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em',alignSelf:'center'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'100%'}}> 
                {
                  quizselection.q7 ===1 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q7=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Music tracks
                  </div>
                }

                {
                  quizselection.q7 !==1 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q7=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Music tracks
                  </div>
                } 

                {
                  quizselection.q7 ===2 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q7=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Music videos
                  </div>
                }

                {
                  quizselection.q7 !==2 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q7=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Music videos
                  </div>
                } 

                {
                  quizselection.q7 ===3 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q7=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Live performances
                  </div>
                }

                {
                  quizselection.q7 !==3 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q7=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Live performances
                  </div>
                }   

                {
                  quizselection.q7 ===4 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q7=4;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Podcasts
                  </div>
                }

                {
                  quizselection.q7 !==4 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q7=4;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                 Podcasts
                  </div>
                }   

                {/* {
                  quizselection.q7 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                } */}
                 
              </div>
          </div>
        }

{
          !quizDone &&
          <div style={{display:'flex',flexDirection:'column',marginTop:'-2.5em'}} className={question===-7?'QuestionSlideContainershowfromleft':'QuestionSlideContainerhidefromleft'}>
            
              <div style={{display:'flex',flexDirection:'column',marginLeft:'0.5em'}}> 
                
                  <div className='questionnumber'>7 of 10</div>
                  <div className='questionName'>What types of content do you primarily produce?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em',alignSelf:'center'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'100%'}}> 
                {
                  quizselection.q7 ===1 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q7=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Music tracks
                  </div>
                }

                {
                  quizselection.q7 !==1 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q7=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Music tracks
                  </div>
                } 

                {
                  quizselection.q7 ===2 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q7=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Music videos
                  </div>
                }

                {
                  quizselection.q7 !==2 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q7=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Music videos
                  </div>
                } 

                {
                  quizselection.q7 ===3 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q7=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Live performances
                  </div>
                }

                {
                  quizselection.q7 !==3 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q7=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Live performances
                  </div>
                }   

                {
                  quizselection.q7 ===4 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q7=4;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Podcasts
                  </div>
                }

                {
                  quizselection.q7 !==4 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q7=4;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                 Podcasts
                  </div>
                }   

                {
                  quizselection.q7 !==0 &&
                  <div className='ContinueQuizBtn' style={{width:'80%'}} onClick={()=>setQuestion(-1*question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
                 
              </div>
          </div>
        }

      {
          !quizDone &&
          <div style={{display:'flex',flexDirection:'column'}} className={question===8?'QuestionSlideContainershow':'QuestionSlideContainerhide'}>
            
              <div style={{display:'flex',flexDirection:'column',marginLeft:'0.5em'}}> 
                  
                  <div className='questionnumber'>8 of 10</div>
                  <div className='questionName'>Is international distribution important to you?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em',alignSelf:'center'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'100%'}}> 
                {
                  quizselection.q8 ===1 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q8=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Yes, I want global reach
                  </div>
                }

                {
                  quizselection.q8 !==1 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q8=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Yes, I want global reach
                  </div>
                } 

                {
                  quizselection.q8 ===2 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q8=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  I prefer to focus on specific markets
                  </div>
                }

                {
                  quizselection.q8 !==2 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q8=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  I prefer to focus on specific markets
                  </div>
                } 

                {
                  quizselection.q8 ===3 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q8=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                 Local distribution is my focus
                  </div>
                }

                {
                  quizselection.q8 !==3 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q8=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Local distribution is my focus
                  </div>
                }  
               
               {/* {
                  quizselection.q8 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                } */}
                 
              </div>
          </div>
        } 

{
          !quizDone &&
          <div style={{display:'flex',flexDirection:'column'}} className={question===-8?'QuestionSlideContainershowfromleft':'QuestionSlideContainerhidefromleft'}>
            
              <div style={{display:'flex',flexDirection:'column',marginLeft:'0.5em'}}> 
                  
                  <div className='questionnumber'>8 of 10</div>
                  <div className='questionName'>Is international distribution important to you?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em',alignSelf:'center'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'100%'}}> 
                {
                  quizselection.q8 ===1 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q8=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                   Yes, I want global reach
                  </div>
                }

                {
                  quizselection.q8 !==1 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q8=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Yes, I want global reach
                  </div>
                } 

                {
                  quizselection.q8 ===2 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q8=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  I prefer to focus on specific markets
                  </div>
                }

                {
                  quizselection.q8 !==2 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q8=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  I prefer to focus on specific markets
                  </div>
                } 

                {
                  quizselection.q8 ===3 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q8=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                 Local distribution is my focus
                  </div>
                }

                {
                  quizselection.q8 !==3 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q8=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Local distribution is my focus
                  </div>
                }  
               
               {
                  quizselection.q8 !==0 &&
                  <div className='ContinueQuizBtn' style={{width:'80%'}} onClick={()=>setQuestion(-1*question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
                 
              </div>
          </div>
        } 

        {
         !quizDone &&
          <div style={{display:'flex',flexDirection:'column'}} className={question===9?'QuestionSlideContainershow':'QuestionSlideContainerhide'}>
            
              <div style={{display:'flex',flexDirection:'column',marginLeft:'0.5em'}}> 
                  
                  <div className='questionnumber'>9 of 10</div>
                  <div className='questionName'>How important is managing your music rights to you?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em',alignSelf:'center'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'100%'}}> 
                {
                  quizselection.q9 ===1 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q9=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Very important—I want full control and protection
                  </div>
                }

                {
                  quizselection.q9 !==1 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q9=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Very important—I want full control and protection
                  </div>
                } 

                {
                  quizselection.q9 ===2 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q9=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Somewhat important
                  </div>
                }

                {
                  quizselection.q9 !==2 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q9=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Somewhat important
                  </div>
                } 

                {
                  quizselection.q9 ===3 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q9=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  I'm not sure
                  </div>
                }

                {
                  quizselection.q9 !==3 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q9=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  I'm not sure
                  </div>
                }  

                {/* {
                  quizselection.q9 !==0 &&
                  <div className='ContinueQuizBtn' onClick={()=>setQuestion(question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                } */}
                 
              </div>
          </div>
        }   

{
         !quizDone &&
          <div style={{display:'flex',flexDirection:'column'}} className={question===-9?'QuestionSlideContainershowfromleft':'QuestionSlideContainerhidefromleft'}>
            
              <div style={{display:'flex',flexDirection:'column',marginLeft:'0.5em'}}> 
                  
                  <div className='questionnumber'>9 of 10</div>
                  <div className='questionName'>How important is managing your music rights to you?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em',alignSelf:'center'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'100%'}}> 
                {
                  quizselection.q9 ===1 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q9=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Very important—I want full control and protection
                  </div>
                }

                {
                  quizselection.q9 !==1 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q9=1;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Very important—I want full control and protection
                  </div>
                } 

                {
                  quizselection.q9 ===2 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q9=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Somewhat important
                  </div>
                }

                {
                  quizselection.q9 !==2 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q9=2;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  Somewhat important
                  </div>
                } 

                {
                  quizselection.q9 ===3 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q9=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  I'm not sure
                  </div>
                }

                {
                  quizselection.q9 !==3 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q9=3;setRefreshQuiz(Math.random());setAnimationDelay(2)}}>
                  I'm not sure
                  </div>
                }  

                {
                  quizselection.q9 !==0 &&
                  <div className='ContinueQuizBtn' style={{width:'80%'}} onClick={()=>setQuestion(-1*question+1)}>
                  CONTINUE
                  <div className="HoverOverlay" style={{top:'0em'}}/>
                   </div>
                }
                 
              </div>
          </div>
        }   

        {
           !quizDone &&
          <div style={{display:'flex',flexDirection:'column'}} className={question===10?'QuestionSlideContainershow':'QuestionSlideContainerhide'}>
            
              <div style={{display:'flex',flexDirection:'column',marginLeft:'0.5em'}}> 
                
                  <div className='questionnumber'>10 of 10</div>
                  <div className='questionName'>How much technical support do you anticipate needing?</div>
                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em',alignSelf:'center'}}>
                        <div style={{width:'5em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'1em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/>
                        <div style={{width:'1.18em',height:'0.18em',backgroundColor:'#FFFFFF',marginRight:'2em'}} className='DynamicBackground'/> 
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'100%'}}> 
                {
                  quizselection.q10 ===1 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q10=1;setQuizDone(true);setRefreshQuiz(Math.random());setTimeLeft(5)}}>
                  A lot—I want hands-on assistance
                  </div>
                }

                {
                  quizselection.q10 !==1 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q10=1;setQuizDone(true);setRefreshQuiz(Math.random());setTimeLeft(5)}}>
                  A lot—I want hands-on assistance
                  </div>
                } 

                {
                  quizselection.q10 ===2 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q10=2;setQuizDone(true);setRefreshQuiz(Math.random());setTimeLeft(5)}}>
                  Occasional help
                  </div>
                }

                {
                  quizselection.q10 !==2 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q10=2;setQuizDone(true);setRefreshQuiz(Math.random());setTimeLeft(5)}}>
                  Occasional help
                  </div>
                } 

                {
                  quizselection.q10 ===3 &&
                  <div className='QuestionOptionContainerSel' style={{width:'80%'}} onClick={()=>{quizselection.q10=3;setQuizDone(true);setRefreshQuiz(Math.random());setTimeLeft(5)}}>
                  I can manage on my own
                  </div>
                }

                {
                  quizselection.q10 !==3 &&
                  <div className='QuestionOptionContainer' style={{width:'80%'}} onClick={()=>{quizselection.q10=3;setQuizDone(true);setRefreshQuiz(Math.random());setTimeLeft(5)}}>
                  I can manage on my own
                  </div>
                }  
               
                 
              </div>
          </div>
        }  
         

        {
          quizDone &&
          <div style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center'}}>
            <div className='FindingPlan'>
              Finding the best plan...
            </div>
            <CircularProgress style={{width:'5em',height:'5em',marginTop:'2.5em'}} sx={{color:'#E91353'}}/>
          </div>
        }

    </div>
    }


    </div>
  );
}

export default Questionaire;